import { getFunctions, httpsCallable } from 'firebase/functions';

class QAReportService {
  constructor() {
    this.functions = getFunctions();
  }

  async generateReport(type = 'daily', date = '', notes = '', cohortIds = []) {
    const callable = httpsCallable(this.functions, 'generateQAReport');
    const payload = { type };
    if (date) {
      payload.date = date;
    }
    if (notes && notes.trim()) {
      payload.notes = notes.trim();
    }
    if (Array.isArray(cohortIds) && cohortIds.length) {
      payload.cohortIds = cohortIds;
    }
    const result = await callable(payload);
    return result.data;
  }
}

const qaReportService = new QAReportService();
export default qaReportService;
